/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Spinner from 'react-bootstrap/Spinner'
import Select from 'react-select'

interface DefaultTermCreateProps {
	show: boolean;
	handleClose: any;
	id: number;
}

interface DefaultTermForm {
	idDefaultTerms: number | null;
	idProjects: number | null;
	terms: string;
}

const DefaultTermCreate: React.FC<DefaultTermCreateProps> = ({ show, handleClose, id }) => {

	const initialState: DefaultTermForm = {
		idDefaultTerms: null,
		idProjects: null,
		terms: '',
	};

	const [form, setForm] = useState(initialState);
	const [projects, setProjects] = useState([]);
	const [project, setProject] = useState({ label: 'Select Project', value: '' });

	useEffect(() => {
		if (show) {
			getProjects();
		}
	}, [show]);

	useEffect(() => {
		if (!show) {
			return;
		}

		if (id === 0) {
			setForm(initialState);
			setProject({ label: 'Select Project', value: '' });
		} else {
			fetch(
				process.env.REACT_APP_API_URL + 'default-terms/' + id,
				getRequestOptions()
			)
				.then((resp) => resp.json())
				.then((resp) => {
					setForm({
						idDefaultTerms: resp.data.idDefaultTerms,
						idProjects: resp.data.idProjects,
						terms: resp.data.terms,
					});
					setProject({ label: resp.data.projectName, value: resp.data.idProjects });
				})
				.catch((error) => {
					console.log(error, 'catch the hoop')
				})
		}
	}, [id, show]);

	const getProjects = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'lead/projects',
			getRequestOptions()
		)
			.then((resp) => resp.json())
			.then((resp) => {
				const projectObj = resp.data.map((item: any) => ({
					...item,
					label: item.name,
					value: item.id,
				}));
				setProjects(projectObj);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const handleProjectChange = (selectedProject: any) => {
		setProject(selectedProject);
		setForm({ ...form, idProjects: selectedProject.value });
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};

	const [isSubmitDisable, setSubmitDisable] = useState(false);
	const [loading, setLoading] = useState(false);

	const defaultTermSave = async (event: any) => {
		event.preventDefault()
		setSubmitDisable(true);
		setLoading(true);
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: 'You want to ' + (id === 0 ? 'create' : 'update') + ' this default term?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Submit it!',
		})
		if (confirm.value) {
			const requestOptions = postRequestOptions(form)
			const url = (id === 0)
				? `${process.env.REACT_APP_API_URL}default-terms/store`
				: `${process.env.REACT_APP_API_URL}default-terms/update`
			try {
				let response = await fetch(url, requestOptions)
				let respData = await response.json()
				if (respData.success === true) {
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: respData.successMessage,
					})
					handleClose(respData.success)
				} else {
					const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: errorsMessage,
					})
				}
				setSubmitDisable(false);
				setLoading(false);
			} catch (error) {
				console.log(error, 'catch the hoop')
				setSubmitDisable(false);
				setLoading(false);
			}
		} else {
			setSubmitDisable(false);
			setLoading(false);
		}
	}

	return (
		<Modal show={show} onHide={() => handleClose(false)} size="lg">
			<form onSubmit={defaultTermSave}>
				<Modal.Header closeButton>
					<Modal.Title>{id === 0 ? 'Create' : 'Edit'} Default Term</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row mb-3">
						<label htmlFor="idProjects" className="col-lg-3 col-form-label" style={{ textAlign: 'right' }}>Project <span className="required text-danger"></span></label>
						<div className="col-lg-8">
							<Select
								value={project}
								onChange={handleProjectChange}
								options={projects}
								menuPosition="fixed"
								styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
							/>
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="terms" className="col-lg-3 col-form-label" style={{ textAlign: 'right' }}>Terms <span className="required text-danger"></span></label>
						<div className="col-lg-8">
							<textarea
								name="terms"
								id="terms"
								value={form.terms}
								onChange={handleChange}
								className="form-control form-control-sm"
								rows={4}
								maxLength={512}
							/>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={() => handleClose(false)}>
						Close
					</Button>
					<Button variant="primary" type="submit" disabled={isSubmitDisable}>
						{loading && (
							<Spinner
								as="span"
								animation="border"
								size="sm"
								role="status"
								aria-hidden="true"
							/>
						)} Submit
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	)
}

export default DefaultTermCreate
